import { createRootSelector } from "../../../utils/createSelector.mjs";
export const gridRowsMetaSelector = createRootSelector(state => state.rowsMeta);